/* eslint-disable react/destructuring-assignment */
import React from "react";
import { string, bool, shape } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import { useParams } from "react-router-dom";

const SummaryBody = (props) => {
    const {
        sellerName = props.sellerName,
        debitAccountMask = props.debitAccountMask,
        quantity = props.quantity,
        currency = props.currency,
        issuedDate = props.issuedDate,
        expirationDate = props.expirationDate,
        debinId = props.debinId,
        sellerCbu = props.sellerCbu,
        sellerAlias = props.sellerAlias,
        sellerBank = props.sellerBank,
        sellerBranch = props.sellerBranch,
        concept = props.concept,
        quote = props.quote,
        reference = props.reference,
        isDesktop = props.isDesktop,
    } = props;

    const { id } = useParams();

    return (
        <>
            <GridTable className="details box box-shadow">
                <GridTable.Container columns={6} rows={4}>
                    {/* Fila 1 */}
                    <GridTable.Data className="flex align-items-end" rowStart={1} columnStart={1} columnWidth={2}>
                        <CustomData
                            className="data-label-name"
                            titleText="debin.seller"
                            titleTextType="I18N"
                            valueText={sellerName}
                        />
                    </GridTable.Data>

                    <GridTable.Data className="flex align-items-end" rowStart={1} columnStart={3} columnWidth={2}>
                        <CustomData
                            titleText="debin.dateExpitation"
                            titleTextType="I18N"
                            valueText={debitAccountMask}
                        />
                    </GridTable.Data>

                    <GridTable.Data className="flex align-items-end" rowStart={1} columnStart={5} columnWidth={2}>
                        <CustomData
                            titleText="debin.amount"
                            titleTextType="I18N"
                            valueText={<FormattedAmount currency={currency} quantity={quantity} />}
                        />
                    </GridTable.Data>

                    {/* Fila 2 */}
                    <GridTable.Data columnStart={1} rowStart={2} columnWidth={2}>
                        <CustomData
                            titleText="debin.solicit.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={issuedDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={3} rowStart={2} columnWidth={2}>
                        <CustomData
                            titleText="debin.expirery.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={expirationDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={5} rowStart={2} columnWidth={2}>
                        <CustomData titleText="debin.id" titleTextType="I18N" valueText={debinId} />
                    </GridTable.Data>

                    {/* Fila 3 */}
                    <GridTable.Data columnStart={1} rowStart={3} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData titleText="debin.cbu" titleTextType="I18N" valueText={sellerCbu} />
                    </GridTable.Data>

                    <GridTable.Data columnStart={3} rowStart={3} columnWidth={2}>
                        <CustomData titleText="debin.alias" titleTextType="I18N" valueText={sellerAlias} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={5} rowStart={3} columnWidth={2}>
                        <CustomData
                            titleText="debin.bank.branch"
                            titleTextType="I18N"
                            valueText={`${sellerBank}/${sellerBranch}`}
                        />
                    </GridTable.Data>

                    {/* Fila 4 */}
                    <GridTable.Data columnStart={1} rowStart={4} columnWidth={2}>
                        <CustomData titleText="debin.concept.label" titleTextType="I18N" valueText={concept} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={3} rowStart={4} columnWidth={2}>
                        <CustomData titleText="tableHeader.quota" titleTextType="I18N" valueText={quote} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={5} rowStart={4} columnWidth={2}>
                        <CustomData titleText="debin.reference" titleTextType="I18N" valueText={reference} />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

SummaryBody.propTypes = {
    sellerName: string,
    debitAccountMask: string,
    quantity: string,
    currency: string,
    issuedDate: string,
    expirationDate: string,
    debinId: string,
    sellerCbu: string,
    sellerAlias: string,
    sellerBank: string,
    sellerBranch: string,
    concept: string,
    quote: string,
    reference: string,
    isDesktop: bool,
};

SummaryBody.defaultProps = {
    sellerName: "",
    debitAccountMask: "",
    quantity: "",
    currency: "",
    issuedDate: "",
    expirationDate: "",
    debinId: "",
    sellerCbu: "",
    sellerAlias: "",
    sellerBank: "",
    sellerBranch: "",
    concept: "",
    quote: "",
    reference: "",
    isDesktop: true,
};

export default SummaryBody;
